import AdminLayout from "../../../components/admin/layout/AdminLayout";
import VarifyRequest from "../../../components/admin/buyer/VarifyRequest";

function VerifyRequestPage() {
  return (
    <AdminLayout>
      <VarifyRequest />
    </AdminLayout>
  );
}

export default VerifyRequestPage;
